import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

const AndroidDesktopViewModal = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Switch to Mobile View</ModalHeader>
      <ModalBody>
        <div style={{ padding: "16px" }}>
          <p>
            It looks like you are using <b>Desktop View</b> on your Android device.
            For the best experience, please switch back to <b>Mobile View</b>.
          </p>
          <p><b>Instructions:</b></p>
          <ol>
            <li>Open your browser menu (usually three dots in the corner).</li>
            <li>Go to <b>Settings</b>.</li>
            <li>Select <b>Site Settings</b>.</li>
            <li>Tap on <b>Desktop Site</b>.</li>
            <li>Choose: <b>Request Mobile View</b>.</li>
          </ol>
        </div>

      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={toggle}>
          Got it
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AndroidDesktopViewModal
